
let __insertScript = (src, id) => {
  (function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = src;
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', id));
};

let initFacebookSDK = (callback) => {
  if (!process.env.MIX_FACEBOOK_APP_ID) throw 'FACEBOOK APP ID IS NOT PROVIDED';

  if (window.FB) {
    callback();
    return;
  }

  __insertScript('https://connect.facebook.net/en_US/sdk.js', 'facebook-js-sdk');

  window.fbAsyncInit = () => {
    FB.init({
      appId      : process.env.MIX_FACEBOOK_APP_ID,
      cookie     : true,
      xfbml      : false,
      version    : 'v4.0'
    });

    callback();
  };
};

let initGoogleSDK = (callback) => {
  if (!process.env.MIX_GOOGLE_CLIENT_ID) throw 'GOOGLE CLIENT ID IS NOT PROVIDED';

  if (window.gapi) {
    if (window.google_auth2 && window.google_auth2.isSignedIn.get()) {
      window.google_auth2.signOut().then(callback);
    } else {
      callback();
    }

    return;
  }

  __insertScript('https://apis.google.com/js/platform.js?onload=onGapiLoad', 'google-js-sdk');

  window.onGapiLoad = () => {
    window.gapi.load('auth2', () => {
      window.google_auth2 = window.gapi.auth2.init({
        client_id: process.env.MIX_GOOGLE_CLIENT_ID,
        fetch_basic_profile: true,
        scope: 'email profile openid'
      });

      window.onbeforeunload = () => {
        google_auth2.signOut();
      }; // Disable google sign in autologin

      callback();
    });
  };
};

export {
  initFacebookSDK,
  initGoogleSDK
}


// WEBPACK FOOTER //
// ./src/utils/socials.js